export default __webpack_public_path__ + "static/media/hoppia_vtuber_blue.c6aba6b4.svg";